import classNames from 'classnames'

import Image from '../Image/Image'
import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'
import { getImageUrl, isArabic } from '../../../utils'

import styles from './ProfileCard.module.scss'
import Arrow from '../../../assets/images/arrow.svg'
import Badge from '../../../assets/images/badge.svg'

const ProfileCard = ({
  cardDetail,
  handleView,
  topAnimation = false,
  className,
}) => {
  const { language } = useLanguage()
  return (
    <div
      className={classNames(
        styles['card-container'],
        'w-full h-full relative p-0 overflow-hidden',
        className
      )}
      onClick={() => handleView && handleView(cardDetail)}
    >
      {topAnimation && (
        <div
          className={classNames(
            styles['top-container'],
            'absolute left-0 top-0 flex items-start bg-white gap-1',
            { [styles.arabicTopContainer]: isArabic(language.code) }
          )}
        >
          <img src={Badge} alt="Badge" className={classNames(styles.badge)} />
          <div className={classNames(styles['top-content'])}>
            {cardDetail?.designationgroup}
          </div>
        </div>
      )}
      <Image
        src={getImageUrl(cardDetail?.image)}
        alt={cardDetail?.image?.alternativeText}
        className={classNames(styles.image, 'block w-full h-auto')}
      />
      <div
        className={classNames(
          styles['bottom-container'],
          'absolute bottom-0 left-0 w-full flex items-end justify-between'
        )}
      >
        <div className={classNames(styles['bottom-content'], 'text-white')}>
          <div className={classNames(styles.name, 'mb-2')}>
            {cardDetail?.title} {cardDetail?.firstname} {cardDetail?.middlename}{' '}
            {cardDetail?.lastname}
          </div>
          <div className={classNames(styles.designation)}>
            {cardDetail?.designation}
          </div>
        </div>
        {cardDetail?.description && (
          <div
            className={classNames(
              styles['action-wrapper'],
              'bg-white relative',
              { [styles['arabic-action-wrapper']]: isArabic(language.code) }
            )}
          >
            <img
              src={Arrow}
              alt="Arrow"
              className={classNames(
                styles['action-image'],
                'block cursor-pointer'
              )}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProfileCard
